<div class="background-overlay" [hidden]="!isOpen"></div>